import React from 'react'
import ModalAlert from 'src/components/ModalAlert'

const ModalPleaseRebeep = ({ show, action }) => (
  <ModalAlert
    show={show}
    action={action}
    title="Rebipar"
    message="Código de barras não encontrado. Favor bipar novamente."
  />
)

export default ModalPleaseRebeep
